<template>
  <header class="d-flex flex-wrap align-items-center justify-content-center justify-content-md-between py-3 mb-4 border-bottom bg-white shadow-sm ">
      <router-link to="/" class="d-flex align-items-center col-md-3 m-2 mb-md-0 text-dark text-decoration-none">
        <img src="../assets/logo.png" alt="Logo" class="img-fluid d-flex align-items-center justify-content-center">
      </router-link>

      <ul class="nav col-12 col-md-auto mb-2 justify-content-center mb-md-0">
        <li><router-link to="/" :class="home" @click="isActive('inicio')">Inicio</router-link></li>
        <li><router-link to="/servicio" :class="service" @click="isActive('servicio')">Servicios</router-link></li>
        <li><router-link to="/contacto" :class="contact" @click="isActive('contacto')">Contacto</router-link></li>
        <li><router-link to="/desarrollo" :class="develop" @click="isActive('desarrollo')">Desarrollos</router-link></li>
        <li><router-link to="/acercade" :class="about" @click="isActive('acercade')">Acerca de</router-link></li>
      </ul>

      <div class="col-md-3 text-end">
      </div>
    </header>
</template>

<script>
export default {
    data: () => ({
        option: false,
        select: "nav-link px-2 link-secondary",
        notSelect: "nav-link px-2 link-dark",
        home: "nav-link px-2 link-dark",
        service: "nav-link px-2 link-dark",
        contact: "nav-link px-2 link-dark",
        develop: "nav-link px-2 link-dark",
        about: "nav-link px-2 link-dark",
    }),
    mounted(){
        this.isActive('inicio');
    },
    methods:{
        isActive(path){
            if("inicio" == path){
                this.home = this.select;
            }
            else{
                this.home = this.notSelect;
            }
            if("servicio" == path){
                this.service = this.select;
            }
            else{
                this.service = this.notSelect;
            }
            if("contacto" == path){
                this.contact = this.select;
            }
            else{
                this.contact = this.notSelect;
            }
            if("desarrollo" == path){
                this.develop = this.select;
            }
            else{
                this.develop = this.notSelect;
            }
            if("acercade" == path){
                this.about = this.select;
            }
            else{
                this.about = this.notSelect;
            }
        }
    }
}
</script>

<style scoped>
    .form-control-dark {
        border-color: var(--bs-gray);
    }

    .form-control-dark:focus {
        border-color: #fff;
        box-shadow: 0 0 0 .25rem rgba(255, 255, 255, .25);
    }

    .text-small {
        font-size: 85%;
    }

    .dropdown-toggle {
        outline: 0;
    }

    img{
        width: 12%;
        text-align: left;
    }
</style>